import React from "react"
import { Link } from "gatsby"
import moment from "moment/moment"
import 'moment/locale/it'
import srcImgFeatured from '../fonts/img_featured_placeholder.jpg'
// import srcImgShare from '../fonts/share.png'
// import srcImgPrefered from '../fonts/off.png'
import styled from 'styled-components'
// import { window, document } from 'browser-monads';
// import { toast } from 'react-toastify'
// import { ToastContainer } from 'react-toastify'
import SharePanel from "../components/share"
// import { useState, useEffect } from 'react'
// import { useLayoutEffect } from 'react'
import { CategoryColor } from "../utils/CategoryColor"


const ImgFeatured = styled.div`
    /*max-height: 260px;*/
    height: 100%;
    position: absolute;

    top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-size: cover;
      background-position: center;
      border-radius: 10px;
      overflow: hidden;

      @media only screen and (max-width:699px)  {
        border-radius: 0px;
      }

`

function PostHeaderMeta({
  title,
  author,
  date,
  uri,
  link,
  excerpt,
  featuredImage,
  content,
  duration,
  address,
  city,
  startDate,
  endDate,
  externalLink,
  province,
  zip,
  vertical,
  postId,
  kind,
}) {
  var primary_category = "AGENDA"
  var primary_category_link = "/agenda"
  var video_embedded_home = ""
  var video_content = ""

  // useLayoutEffect(() => {
  //   const handleScroll = () => {
  //     // const isScrolled = window.scrollY > 10;

  //     if (document.localStorage ) {
  //        is_prefered = document.localStorage.getItem(window.location.pathname+'_prefered')
  //        reset_pref_color()
  //     }

  //     window.addEventListener("load", reset_pref_color)

  //   };
  //   return () => {
  //     window.removeEventListener("load", reset_pref_color)
  //   };
  // }/*, [scrolled]*/);

  return (
    <header className="entry-headers" style={{ marginTop: "60px" }}>
      <div className="entry-metas">
        <div
          className="show_mobile"
          style={{
            marginTop: "58px",
            position: "relative",
            paddingTop: "52%",
            overflow: "hidden",
            textAlign: "center",
          }}
        >
          <ImgFeatured
            className="announcement-event-image"
            style={{
              backgroundImage:
                "url(" + (featuredImage ? featuredImage : srcImgFeatured) + ")",
            }}
            src={featuredImage ? featuredImage : srcImgFeatured}
            alt={"desc"}
          />
        </div>
        <span className="byline" style={{ width: "100%" }}>
          <span
            className="posted-on"
            style={{
              display: "flex",
              width: "100%",
              marginTop: "15px",
              marginBottom: "3rem",
            }}
          >
            <div
              className="show_desktop byline"
              style={{
                display: "flex",
                width: "83%",
                background: "white",
                position: "fixed",
                top: "0",
                zIndex: "99",
              }}
            >
              <span
                className="byline mag_fixed_header"
                style={{
                  width: "100%",
                  height: "92px",
                  background: "white",
                }}
              >
                <span
                  className="posted-on"
                  style={{
                    display: "block",
                    width: "100%",
                    marginTop: "20px",
                    marginBottom: "15px",
                  }}
                >
                  <Link
                    style={{ width: "fit-content", float: "left" }}
                    to={primary_category_link.replace(
                      "https://new.startupitalia.eu",
                      ""
                    )}
                  >
                    <div
                      style={{
                        marginLeft: "15px",
                        fontSize: "13px",
                        borderRadius: "5px",
                        backgroundColor: new CategoryColor(primary_category)
                          .color,
                        color: "white",
                        textAlign: "center",
                        width: "fit-content",
                        padding: "10px",
                      }}
                    >
                      {primary_category}
                    </div>
                  </Link>
                  <SharePanel
                    float="right"
                    margin=""
                    title={title}
                    components_name_md5="_header"
                    img={featuredImage ? featuredImage.mediaItemUrl : ""}
                    author={""}
                    video={
                      video_embedded_home !== undefined
                        ? JSON.stringify(video_embedded_home)
                        : ""
                    }
                    is_media={video_content}
                    vertical={vertical}
                    postId={postId}
                    kind={kind}
                  />
                </span>
              </span>
            </div>
            <div className="show_mobile" style={{ display: "flex" }}>
              <span
                className="byline byline_mobile"
                id="byline_mobile"
                style={{ width: "100%", backgroundColor: "white" }}
              >
                <span
                  className="posted-on posted-on_mobile"
                  id="posted_on_mobile"
                  style={{
                    display: "flex",
                    width: "100%",
                    marginTop: "20px",
                    marginBottom: "15px",
                  }}
                >
                  <Link
                    style={{ width: "fit-content" }}
                    to={primary_category_link.replace(
                      "https://new.startupitalia.eu",
                      ""
                    )}
                  >
                    <div
                      id="newmag_mobile_primary_category"
                      style={{
                        marginLeft: "15px",
                        fontSize: "13px",
                        borderRadius: "5px",
                        backgroundColor: new CategoryColor(primary_category)
                          .color,
                        color: "white",
                        textAlign: "center",
                        width: "fit-content",
                        padding: "10px",
                      }}
                    >
                      {primary_category}
                    </div>
                  </Link>
                  <SharePanel
                    title={title}
                    components_name_md5="_headermobile"
                    img={featuredImage ? featuredImage.mediaItemUrl : ""}
                    author={""}
                    video={JSON.stringify(video_embedded_home)}
                    is_media={video_content}
                  />
                </span>
              </span>
            </div>
          </span>
        </span>{" "}
      </div>

      <h2 className="entry-title" dangerouslySetInnerHTML={{ __html: title }} />
      <div
        className="entry-excerpt"
        dangerouslySetInnerHTML={{ __html: excerpt }}
      />
      <div style={{ display: "flex", width: "fit-content" }}>
        <img
          className="newmag_agenda_icon_invert"
          style={{ margin: "auto" }}
          src={"/img/agenda_date_icon.png"}
          width="50px"
          height="50px"
          alt="Agenda"
        />
        <p>{moment(startDate).locale("it").format(`D MMM YYYY`)}</p>
      </div>
      <div style={{ display: "flex", width: "fit-content" }}>
        <img
          className="newmag_agenda_icon_invert"
          style={{ margin: "auto" }}
          src={"/img/agenda_date_icon.png"}
          width="50px"
          height="50px"
          alt="Agenda"
        />
        <p>{moment(endDate).locale("it").format(`D MMM YYYY`)}</p>
      </div>
      <div
        style={{
          display: address || city ? "flex" : "none",
          width: "fit-content",
        }}
      >
        <img
          className="newmag_agenda_icon_invert"
          style={{ margin: "auto" }}
          src={"/img/agenda_map_icon.png"}
          width="50px"
          height="50px"
          alt="Agenda"
        />
        <p style={{}}>
          {(address ? address : "") +
            (city ? " " + city : "") +
            (province ? " (" + province + ") " : " ") +
            zip}
        </p>
      </div>
      <div style={{ display: "flex", margin: "auto" }}>
        <a
          href={externalLink}
          style={{ display: externalLink ? "flex" : "none", margin: "auto" }}
        >
          <button
            style={{
              height: "60px",
              margin: "auto",
              width: "90%",
              borderRadius: "7px",
              background: "linear-gradient(53.35deg, #EE3D49 0%, #CB356B 100%)",
            }}
          >
            <h2
              style={{
                fontFamily: "aktiv-grotesk",
                fontSize: "19px",
                color: "white",
              }}
            >
              Prendi il biglietto
            </h2>
          </button>
        </a>
      </div>

      <div
        className="show_desktop"
        style={{
          marginTop: "58px",
          position: "relative",
          paddingTop: "52%",
          overflow: "hidden",
          textAlign: "center",
        }}
      >
        <ImgFeatured
          className="announcement-event-image"
          style={{
            backgroundImage:
              "url(" + (featuredImage ? featuredImage : srcImgFeatured) + ")",
          }}
          src={featuredImage ? featuredImage : srcImgFeatured}
          alt={"desc"}
        />
      </div>
    </header>
  )
}

export default PostHeaderMeta
